const AUTH_SERVER_URL = 'https://auth.documedias.com/';

// Production
const AUTH_SERVER_FRONTEND_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJhcHBsaWNhdGlvbklkIjo3ODIsImNvbmdyZXNzSWQiOjEyNDUsImRhdGUiOiIyMDIxLTA1LTA1VDA5OjUzOjE4LjI5MloiLCJpYXQiOjE2MjAyMDgzOTh9.6BRvX4MefxjX9LCdL3LFs2xorYSmooRzken6Nn7HdrU';
const PLANNER_API_URL = 'https://ueg2021.planner.documedias.systems/api';

// Development
// const AUTH_SERVER_FRONTEND_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJhcHBsaWNhdGlvbklkIjo3ODMsImNvbmdyZXNzSWQiOjEyNDUsImRhdGUiOiIyMDIxLTA1LTA1VDA5OjU1OjAwLjgyMFoiLCJpYXQiOjE2MjAyMDg1MDB9.enO0yJ7VLM-iHVyLOlyxbTFOc1GjXGcPk2nz9FEe6ao';
// const PLANNER_API_URL = 'http://localhost:8000/api';

const CONGRESS_ID = 1245;
// const SUBMISSION_API_URL = 'https://ueg2021.abstract.documedias.systems/api/v1/export/transformed/filtered/single/abstract/{{id}}/planner_preview/export';

const SUBMISSION_API_URL = 'https://ueg2021.abstract.documedias.systems/api/v1/manager/abstract/multi/html/id/{{id}}/template/planner_preview';

const SESSION_GROUP_ID = 358;

export {
  AUTH_SERVER_URL,
  AUTH_SERVER_FRONTEND_KEY,
  PLANNER_API_URL,
  CONGRESS_ID,
  SUBMISSION_API_URL,
  SESSION_GROUP_ID,
}
